import apiClient from "./client";
import type {
  DivisionCodesResponse,
  GetDivisionCodesParams,
} from "../types/division-code";

export const getDivisionCodes = async (
  params: GetDivisionCodesParams
): Promise<DivisionCodesResponse> => {
  const { data } = await apiClient.get<DivisionCodesResponse>(
    "/division-codes",
    {
      params: {
        pref_code: params.pref_code,
        order: params.order,
        sort: params.sort,
        page: params.page,
      },
    }
  );
  return data;
};
